const Setup = (() => {
  let setupContainerEle;
  let setupAreaWrapEle;

  // modules/sections
  const CASE_NOTES = 'Case Notes';
  const DAY_SERVICES = 'Day Services';
  const GENERAL = 'General';
  const INCIDENT_TRACKING = 'Incident Tracking';
  const LOGIN_LOGOUT = 'Login / Logout';
  const PLAN = 'Plan';
  const ROSTER = 'Roster';
  const SCHEDULING = 'Scheduling';
  const TIME_ENTRY = 'Time Entry';
  const TRANSPORTATION = 'Transportation';
  const WORKSHOP = 'Workshop';
  const MONEY_MANAGEMENT = 'Money Management';

  // sub-sections
  const SYS_PREF = 'System Preferences';

  let DEFAULT_SECTION;
  const DEFAULT_SUBSECTION = SYS_PREF;

  const ADV_MENU_ITEMS = {
    [DAY_SERVICES]: [SYS_PREF],
    [INCIDENT_TRACKING]: [SYS_PREF],
    [LOGIN_LOGOUT]: [SYS_PREF],
    [MONEY_MANAGEMENT]: ['Account Classes', 'Payees'],
    [PLAN]: [SYS_PREF],
    [ROSTER]: [SYS_PREF],
    [SCHEDULING]: [SYS_PREF],
    [TIME_ENTRY]: [SYS_PREF],
    [TRANSPORTATION]: [SYS_PREF],
    [WORKSHOP]: [SYS_PREF],
  };
  const GK_MENU_ITEMS = {
    [CASE_NOTES]: [SYS_PREF],
    [GENERAL]: [SYS_PREF],
    [LOGIN_LOGOUT]: [SYS_PREF],
    [PLAN]: [SYS_PREF],
    [ROSTER]: [SYS_PREF],
  };

  function loadView(module, section) {
    if (section === SYS_PREF) {
      const newView = SystemPreferences.getView(module);
      setupAreaWrapEle.innerHTML = '';
      setupAreaWrapEle.append(newView);
      return;
    }

    if (module === MONEY_MANAGEMENT) {
      const newView = SetupMoneyManagement.getView(section);
      setupAreaWrapEle.innerHTML = '';
      setupAreaWrapEle.append(newView);
      return;
    }
  }
  function handleMenuClick(e) {
    const target = e.target;

    const module = target.dataset.module;
    const section = target.dataset.section;

    if (!module || !section) return;

    const activeLink = document.querySelector('.setupMenu__subSection.active');
    if (activeLink) activeLink.classList.remove('active');

    target.classList.add('active');

    loadView(module, section);
  }

  function loadPage() {
    let activeMenuItems;
    if ($.session.applicationName === 'Advisor') {
      activeMenuItems = ADV_MENU_ITEMS;
      if (!$.session.flag.moneymanagementSysPref) {
        delete activeMenuItems[MONEY_MANAGEMENT];
      }
    } else {
      activeMenuItems = GK_MENU_ITEMS;
    }

    const setupMenuEle = document.createElement('div');
    setupMenuEle.classList.add('setupMenu');
    Object.entries(activeMenuItems).forEach(([sectionTitle, subSectionTitles]) => {
      const menuGroupEle = document.createElement('div');
      menuGroupEle.classList.add('setupMenu__group');
      setupMenuEle.appendChild(menuGroupEle);

      const sectionEle = document.createElement('p');
      sectionEle.classList.add('setupMenu__section');
      sectionEle.textContent = sectionTitle;
      menuGroupEle.appendChild(sectionEle);

      subSectionTitles.forEach(subSectionTitle => {
        const subSectionEle = document.createElement('p');
        subSectionEle.classList.add('setupMenu__subSection');
        subSectionEle.textContent = subSectionTitle;
        subSectionEle.setAttribute('data-module', sectionTitle);
        subSectionEle.setAttribute('data-section', subSectionTitle);

        menuGroupEle.appendChild(subSectionEle);

        if (DEFAULT_SECTION === sectionTitle && DEFAULT_SUBSECTION === subSectionTitle) {
          subSectionEle.classList.add('active');
        }
      });
    });

    setupAreaWrapEle = document.createElement('div');
    setupAreaWrapEle.classList.add('setupArea');

    setupMenuEle.addEventListener('click', handleMenuClick);

    setupContainerEle.appendChild(setupMenuEle);
    setupContainerEle.appendChild(setupAreaWrapEle);
  }

  async function loadData() {
    if ($.session.flag.moneymanagementSysPref) {
      try {
        const [setupDataResp, mmDropdownDataResp] = await Promise.all([
          _UTIL.fetchData('getSetupPageData', { userId: $.session.UserId }),
          _UTIL.fetchData('getSetupPageDropdownData'),
        ]);

        SystemPreferences.init(setupDataResp.GetSetupPageDataResult.systemPrefereces);
        SetupMoneyManagement.init(
          setupDataResp.GetSetupPageDataResult.moneyManagement,
          mmDropdownDataResp.GetSetupPageDropdownDataResult,
        );

        loadPage();
        loadView(DEFAULT_SECTION, SYS_PREF);
      } catch (error) {
        console.log(error);
      }
    } else {
      await SystemPreferences.init();

      loadPage();
      loadView(DEFAULT_SECTION, SYS_PREF);
    }
  }

  async function init() {
    if (!$.session.flag) $.session.flag = {};
    $.session.flag.moneymanagementSysPref = false;

    DEFAULT_SECTION = $.session.applicationName === 'Gatekeeper' ? CASE_NOTES : DAY_SERVICES;

    setupContainerEle = document.createElement('div');
    setupContainerEle.classList.add('setupContainer');

    DOM.clearActionCenter();
    DOM.ACTIONCENTER.appendChild(setupContainerEle);
    setActiveModuleAttribute('setup');
    _DOM.ACTIONCENTER.setAttribute('data-UI', true);

    loadData();
  }

  return {
    init,
    CASE_NOTES,
    DAY_SERVICES,
    GENERAL,
    INCIDENT_TRACKING,
    LOGIN_LOGOUT,
    PLAN,
    ROSTER,
    SCHEDULING,
    TIME_ENTRY,
    TRANSPORTATION,
    WORKSHOP,
  };
})();
